import React from 'react';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import SimpleModalOrMobilePage from '#/components/basic/modal/SimpleModalOrMobilePage';

export default function ErrorModal({
  errorMessage,
  errorType,
  subMessage,
  onClose,
}: {
  errorMessage: string;
  errorType: 'error' | 'warning' | undefined;
  subMessage?: string;
  onClose: () => void;
}) {
  return (
    <SimpleModalOrMobilePage onClose={onClose} size="small">
      <div style={{ textAlign: 'center', paddingTop: 24 }}>
        {errorType === 'warning' ? (
          <MaterialSymbol
            icon="warning"
            fontSize="large"
            color="var(--warnContent)"
          />
        ) : (
          <MaterialSymbol icon="error" fontSize="large" color="var(--red3)" />
        )}
        {/* We are sorry, but cancellation is temporary disabled. */}
        <h2>
          {errorMessage}
          {/* {errorMessage.split('\n').map(text => (
            <p key={text}>{text}</p>
          ))} */}
        </h2>
        {errorType === 'error' && (
          <p>
            Please try again. If the problem persists, please contact support.
          </p>
        )}
        {subMessage && <p>{subMessage}</p>}
      </div>
    </SimpleModalOrMobilePage>
  );
}
